// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class SupportedAggregationsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.SUPPORTED_AGGREGATIONS_GROUP, null, pfixFieldSet);
    }
    getAggregatedType() {
        return super.GetValue(FieldsFactory.FIELD_AGG_TYPE);
    }
    getAggregatedPeriod() {
        return super.GetValue(FieldsFactory.FIELD_AGG_PERIOD);
    }
    getAggregatedValue() {
        return super.GetValue(FieldsFactory.FIELD_AGG_VALUE);
    }
}
